import { render, staticRenderFns } from "./EditProductModal.vue?vue&type=template&id=59e89064&scoped=true&"
import script from "./EditProductModal.vue?vue&type=script&lang=js&"
export * from "./EditProductModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProductModal.vue?vue&type=style&index=0&id=59e89064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e89064",
  null
  
)

export default component.exports